import { Controller } from "stimulus"

const timeExpando = "__transcript_start_end"

function stepMatchesTime(el, ts, d = 0) {
  const [ start, end ] = el[timeExpando]
  return (start - d) <= ts && ts <= (end + d)
}

export default class extends Controller {
  static classes = [ "highlight" ]
  static targets = [ "step" ]
  static values = { audioTagSelector: String }

  disconnect() {
    this.#removeTimeUpdateListener()
  }

  audioTagSelectorValueChanged() {
    this.#removeTimeUpdateListener()

    this._audioTag = document.querySelector(this.audioTagSelectorValue)
    this._audioTag?.addEventListener("timeupdate", this.#triggerChange)
    this._audioTag?.addEventListener("timeupdate", this.timesync)
  }

  stepTargetConnected(el) {
    try {
      if (!el[timeExpando]) {
        el[timeExpando] = JSON.parse(el.dataset.time)
      }
    } catch {
      // no-op
    }
  }

  #triggerChange = ({ target }) => {
    this.stepTargets.forEach(el => {
      // use the 3rd delta argument to make sure change events entering
      // and leaving the timing range of the step are dispatched as well
      // so that listeners can detect range enter and leave
      if (stepMatchesTime(el, target.currentTime, 1.0)) {
        this.dispatch("change", { target: el, bubbles: false, detail: { audioTag: this._audioTag } })
      }
    })
  }

  timesync = ({ target }) => {
    this.stepTargets.forEach(el => {
      if (stepMatchesTime(el, target.currentTime)) {
        el.classList.add(this.highlightClass)
      } else {
        el.classList.remove(this.highlightClass)
      }
    })
  }

  #removeTimeUpdateListener() {
    this._audioTag?.removeEventListener("timeupdate", this.#triggerChange)
    this._audioTag?.removeEventListener("timeupdate", this.timesync)
  }
}
